import { FC, useState } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useMissionClaims } from '../../../../hooks/useUser';
import { fmtDate } from '../../userShowUtils';
import { PaginatedSection } from '../../userShowComponents';

/** ④-3. 미션 — claim 내역 목록(페이징) */
const MissionTab: FC<{ userId: number }> = ({ userId }) => {
    const [page, setPage] = useState(1);
    const { data, isLoading } = useMissionClaims(userId, page - 1);
    const claims = data?.content ?? [];

    return (
        <PaginatedSection
            loading={isLoading} empty={claims.length === 0} emptyText="수령한 미션 보상이 없습니다."
            page={page} totalPages={data?.totalPages ?? 0} onPageChange={setPage}
        >
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>미션</TableCell>
                        <TableCell>tier</TableCell>
                        <TableCell>기간</TableCell>
                        <TableCell align="right">보상 깃털</TableCell>
                        <TableCell>보상 코스튬</TableCell>
                        <TableCell>수령 일시</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {claims.map((c) => (
                        <TableRow key={c.id}>
                            <TableCell>
                                <Typography variant="body2" fontWeight={600}>{c.missionName}</Typography>
                                <Typography variant="caption" color="text.secondary">{c.missionCode}</Typography>
                            </TableCell>
                            <TableCell>{c.tierIndex}</TableCell>
                            <TableCell>{c.periodKey}</TableCell>
                            <TableCell align="right">+{c.rewardXp.toLocaleString()}</TableCell>
                            <TableCell>{c.rewardCostumeName ?? '-'}</TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>{fmtDate(c.claimedAt)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </PaginatedSection>
    );
};

export default MissionTab;
